import { useState } from 'react'
import styled from 'styled-components'

export const SourceTable = ({ sources }: { sources: any[] }) => {
  const [open, setOpen] = useState(false)
  return (
    <SourceTableRoot>
      <Head onClick={() => setOpen(!open)}>
      Quellen<div className={open?'arrow-up':'arrow-down'} />
       
      </Head>
      <Tail
        style={{
          maxHeight: open ? '500px' : '0px',
          overflowY: open ? 'scroll' : 'hidden',
        }}
      >
        <Table>
          <tbody>
            {sources.map((e) => {
              return (
                <tr>
                  <td>
                    <b> {e[0]}</b>
                    <a href={e[1].split('[')[1]}>{e[1].split('[')[0]}</a>
                    {e[2] !== '-' && <small>{e[2]}</small>}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </Table>
      </Tail>
    </SourceTableRoot>
  )
}

const Table = styled.table`
  table-layout: fixed;
  line-height: 1.4em;
  small {
    display: inline-block;
    width: 100%;
  }
  a {
    color: var(--text-color);
    text-decoration: none;
    border-bottom: 1px solid var(--text-color);
    padding-bottom: 1px;
  }
  td {
    padding-top: 4px;
    padding-bottom: 4px;
    border-bottom: 1px solid var(--gray-3);
  }
`

const SourceTableRoot = styled.div`
  margin-top: 15px;
  font-size: 12px;
  max-width: 100%;

  color: var(--brandblue-bright-3);

  b {
    font-size: 12.5px;
    margin-right: 4px;
  }
`
const Head = styled.button`
  background-color: transparent;
  border: 0;
  display: flex;
  align-items: center;
  padding-bottom: 4px;
  padding-top: 5px;
  color: var(--brandblue-bright-3);

  &:hover{
    cursor: pointer;
    background-color: var(--gray-5);

  }
  .arrow-up {
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;

    border-bottom: 6px solid var(--brandblue-bright-3);
    margin-right: 2px;
    margin-left: 6px;
    margin-top: 2px;
  }

  .arrow-down {
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;

    border-top: 6px solid var(--brandblue-bright-3);
    margin-right: 2px;
    margin-left: 6px;
    margin-top: -2px;
  }
`
const Tail = styled.div`
  max-height: 500px;
  overflow-y: scroll;
  transition: max-height 0.5s ease-in-out ;
`
